import { connect } from "react-redux";
import ResetPassword from "../components/ResetPassword/ResetPassword";

import * as actions from "../redux/actions/ResetPassword";
import { push } from "react-router-redux";

const mapStateToProps = (state) => {
  return {
    isGettingSecurityQuestion: state.resetPassword.isGettingSecurityQuestion,
    security_question: state.resetPassword.security_question,
    isResetting: state.resetPassword.resetting,
    message: state.resetPassword.message,
    errorMessage: state.resetPassword.errorMessage,
    shortMessage: state.resetPassword.shortMessage,
    error: state.resetPassword.error,
  };
};

const mapDispatchToProps = (dispatch) => ({
  resetPassword(newPasswordInfo) {
    dispatch(actions.resetPassword(newPasswordInfo));
  },

  getPasswordSecurityQuestion(data) {
    dispatch(actions.getPasswordSecurityQuestion(data));
  },

  goTo(url, state) {
    dispatch(push(url, state));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);



// WEBPACK FOOTER //
// ./src/containers/ResetPassword.js